import { create } from "zustand";
import { cropModel } from "../../../common/components/user-invitation-modal/api/types";

export interface UserState {
  showPasswordDialog: boolean;
  setShowPasswordDialog: (val: boolean) => void;
  passwordConfirmCallback: (() => void) | null;
  setPasswordConfirmCallback: (cb: () => void) => void;

  currentEditContext: string;
  setCurrentEditContext: (val: string) => void;

  previewUrl: string | null;
  previewUrl2: string | null;
  originalFileName: string;
  openCropDialog: boolean;
  zoom: number;
  crop: { x: number; y: number };
  croppedAreaPixels: cropModel | null;
  currentPassword: string | null;

  isEditingEmail: boolean;
  setIsEditingEmail: (val: boolean) => void;
  isEditingMobileNumber: boolean;
  setIsEditingMobileNumber: (val: boolean) => void;
  isEditingPassword: boolean;
  setIsEditingPassword: (val: boolean) => void;
  emailOtpSent: boolean;
  setEmailOtpSent: (val: boolean) => void;

  numberOtpSent: boolean;
  setNumberOtpSent: (val: boolean) => void;

  updateNumber: boolean;
  setUpdateNumber: (val: boolean) => void;

  setCroppedAreaPixels: (val: cropModel | null) => void;
  setCrop: (val: { x: number; y: number }) => void;
  setZoom: (val: number) => void;
  setOpenCropDialog: (val: boolean) => void;
  setOriginalFileName: (val: string) => void;
  setCurrentPassword: (val: string | null) => void;

  setPreviewUrl2: (val: string | null) => void;
  setPreviewUrl: (val: string | null) => void;
  isAddModalOpen: boolean;
  setAddModal: (isAddModalOpen: boolean) => void;

  callback: () => void;
  setCallback: (val: () => void) => void;

  emailStatus: "valid" | "invalid" | null;
  setEmailStatus: (status: "valid" | "invalid" | null) => void;
  numberStatus: "valid" | "invalid" | null;
  setNumberStatus: (status: "valid" | "invalid" | null) => void;

  checkingEmail: boolean;
  setCheckingEmail: (val: boolean) => void;
  checkingNumber: boolean;
  setCheckingNumber: (val: boolean) => void;

  passwordValid: {
    minLength: boolean;
    hasUppercase: boolean;
    hasLowercase: boolean;
    hasSpecialChar: boolean;
    hasNumber: boolean;
    passwordsMatch: boolean;
  };
  setPasswordValid: (validations: UserState["passwordValid"]) => void;

  oldPassword: string | null;
  setOldPassword: (password: string) => void;
  showNewPassword: boolean;
  setShowNewPassword: (val: boolean) => void;

  showConfirmPassword: boolean;
  setShowConfirmPassword: (val: boolean) => void;

  openModal: boolean;
  setOpenModal: (openModal: boolean) => void;
  isEditing: boolean;
  setIsEditing: (val: boolean) => void;

  newPassword: string;
  setNewPassword: (val: string) => void;

  confirmPassword: string;
  setConfirmPassword: (val: string) => void;

  emailOTP: string;
  setEmailOTP: (val: string) => void;

  phoneNumberOTP: string;
  setPhoneNumberOTP: (val: string) => void;

  isTwoFactorEnabled: boolean;
  setIsTwoFactorEnabled: (val: boolean) => void;

}

const useUserStore = create<UserState>((set) => ({
  showPasswordDialog: false,
  setShowPasswordDialog: (showPasswordDialog: boolean) =>
    set(() => ({ showPasswordDialog })),
  passwordConfirmCallback: null,
  setPasswordConfirmCallback: (passwordConfirmCallback: () => void) =>
    set(() => ({ passwordConfirmCallback })),
  isAddModalOpen: false,
  currentPassword: null,
  setCurrentPassword: (currentPassword: string | null) =>
    set(() => ({ currentPassword })),
  previewUrl: null,
  previewUrl2: null,
  originalFileName: "",
  openCropDialog: false,
  zoom: 1,
  crop: { x: 0, y: 0 },
  croppedAreaPixels: null,
  setAddModal: (isAddModalOpen) => set({ isAddModalOpen }),
  currentEditContext: "",
  setCurrentEditContext: (val: string) =>
    set(() => ({ currentEditContext: val })),
  isEditingEmail: false,
  setIsEditingEmail: (val: boolean) => set(() => ({ isEditingEmail: val })),
  isEditingMobileNumber: false,
  setIsEditingMobileNumber: (val: boolean) =>
    set(() => ({ isEditingMobileNumber: val })),
  isEditingPassword: false,
  setIsEditingPassword: (val: boolean) =>
    set(() => ({ isEditingPassword: val })),
  emailOtpSent: false,
  setEmailOtpSent: (val) => set({ emailOtpSent: val }),

  numberOtpSent: false,
  setNumberOtpSent: (val) => set({ numberOtpSent: val }),

  updateNumber: false,
  setUpdateNumber: (val) => set({ updateNumber: val }),

  setCroppedAreaPixels: (croppedAreaPixels: cropModel | null) =>
    set(() => ({ croppedAreaPixels })),
  setCrop: (crop: { x: number; y: number }) => set(() => ({ crop })),
  setZoom: (zoom: number) => set(() => ({ zoom })),
  setOpenCropDialog: (openCropDialog: boolean) =>
    set(() => ({ openCropDialog })),
  setOriginalFileName: (originalFileName: string) =>
    set(() => ({ originalFileName })),
  setPreviewUrl2: (previewUrl2: string | null) => set(() => ({ previewUrl2 })),
  setPreviewUrl: (previewUrl: string | null) => set(() => ({ previewUrl })),

  callback: () => {},
  setCallback: (callback: () => void) => set(() => ({ callback })),

  emailStatus: null,
  setEmailStatus: (emailStatus) => set(() => ({ emailStatus })),
  numberStatus: null,
  setNumberStatus: (numberStatus) => set(() => ({ numberStatus })),

  checkingEmail: false,
  setCheckingEmail: (checkingEmail) => set(() => ({ checkingEmail })),

  checkingNumber: false,
  setCheckingNumber: (checkingNumber) => set(() => ({ checkingNumber })),

  passwordValid: {
    minLength: false,
    hasUppercase: false,
    hasLowercase: false,
    hasSpecialChar: false,
    hasNumber: false,
    passwordsMatch: false,
  },
  setPasswordValid: (validations) =>
    set(() => ({ passwordValid: validations })),
  oldPassword: null,
  setOldPassword: (password) => set({ oldPassword: password }),

  showNewPassword: false,
  setShowNewPassword: (showNewPassword: boolean) => set({ showNewPassword }),
  showConfirmPassword: false,
  setShowConfirmPassword: (showConfirmPassword: boolean) =>
    set({ showConfirmPassword }),
  openModal: false,
  setOpenModal: (openModal) => set({ openModal }),
  isEditing: false,
  setIsEditing: (val: boolean) => set(() => ({ isEditing: val })),

  newPassword: "",
  setNewPassword: (val: string) => set(() => ({ newPassword: val })),

  confirmPassword: "",
  setConfirmPassword: (val: string) => set(() => ({ confirmPassword: val })),

  emailOTP: "",
  setEmailOTP: (val: string) => set(() => ({ emailOTP: val })),

  phoneNumberOTP: "",
  setPhoneNumberOTP: (val: string) => set(() => ({ phoneNumberOTP: val })),

  isTwoFactorEnabled: false,  // Default value (can be updated later)
  setIsTwoFactorEnabled: (val) => set({ isTwoFactorEnabled: val }),

}));

export default useUserStore;
